import styled from 'styled-components';
import { ReactComponent as RawSignOutSVG } from '../../../../assets/icons/icon_sign_out.svg';

export const IconSignOut = styled(RawSignOutSVG)``;
